import styles from './MeterSvg.module.css';

import { Color } from '../../styles';

interface MeterSvgProps {
  /** Percentage from 0-100 */
  fillPercentage: number;
}

const stroke = 12;
const radius = 122;
const innerRadius = radius - stroke / 2;
const circumference = innerRadius * 2 * Math.PI;
const arcAngle = 180;
const arc = circumference * (arcAngle / 360);
const markerSize = 3;
const markerOffset = arc + markerSize;
const fillStartPosition = 180;

const dashArray = `${arc} ${circumference}`;
const transform = `rotate(${fillStartPosition}, ${radius}, ${radius})`;

const arcProps = {
  cx: radius,
  cy: radius,
  r: innerRadius,
  fill: 'none',
  strokeWidth: stroke,
  strokeDasharray: dashArray,
  transform: transform,
};

export function MeterSvg({ fillPercentage }: MeterSvgProps) {
  const safeFill = Math.min(Math.max(fillPercentage, 0), 1);

  const fillOffset = arc - safeFill * arc;
  const markerRotation =
    fillStartPosition + Math.max(fillStartPosition * safeFill, markerSize / 2);

  return (
    <svg className={styles.container} viewBox={`0 0 ${radius * 2} ${radius}`}>
      <circle {...arcProps} stroke={Color.Oyster0} />
      <circle
        {...arcProps}
        className={styles.fill}
        stroke={Color.Kale1}
        strokeDashoffset={fillOffset}
      />
      <circle
        {...arcProps}
        className={styles.marker}
        stroke={Color.Charcoal3}
        strokeDashoffset={markerOffset}
        transform={`rotate(${markerRotation}, ${radius}, ${radius})`}
      />
    </svg>
  );
}
